// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import vueDrag from 'vue-dragging'
import VueI18n from 'vue-i18n'
import zh from './i18n/zh'
import en from './i18n/en'
import isSingapore from './setting'
import 'element-ui/lib/theme-chalk/index.css'
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(vueDrag)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: isSingapore ? 'en' : 'zh', // 语言标识
  messages: {
    zh,
    en
  }
})

// eslint-disable-next-line no-new
window.vm = new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js